export const environment = {
  production: false,
  authUrl: 'https://banwebdev.cityu.edu.hk:7065/pls/PRO8/srwwwauth_cityu.refresh_tokens',
  ordsUrl: 'https://esmiscdev.esu.cityu.edu.hk/rests/ho_api/pg',
};


